import Vue from "vue";
import Vuex from "vuex"; //引入 vuex
import createPersistedState from "vuex-persistedstate";
import { BIZ_TOKEN, BIZ_USERINFO, BIZ_CURRENT_CART, BIZ_CART_ITEMS, BIZ_LANG, BIZ_LANGUAGE_MAP } from "@/common/constant";
import { homeMoule } from "@/store/home.module";
import { userMoule } from "@/store/user.module";
import { get_current } from "@/api/order/cart.js"
// import { rechargeMoule } from "@/store/recharge.module";
// import { withdrawMoule } from "@/store/withdraw.module";
// import { productDetailsMoule } from "@/store/productDetails.module";
// import { cartMoule } from "@/store/cart.module";
// import { orderMoule } from "@/store/order.module";
import { showI18nMessage } from '@/common'

Vue.use(Vuex); //使用 vuex

const getDefaultLang = () => localStorage.getItem(BIZ_LANG) || BIZ_LANGUAGE_MAP.en
const defaultLang = getDefaultLang()

export default new Vuex.Store({
  modules: {
    home: homeMoule,
    user: userMoule,
    // recharge: rechargeMoule,
    // withdraw: withdrawMoule,
    // productDetails: productDetailsMoule,
    // cart: cartMoule,
    // order: orderMoule,
  },
  state: {
    token: sessionStorage.getItem(BIZ_TOKEN) ? sessionStorage.getItem(BIZ_TOKEN) : null,
    lang: defaultLang,
    userInfo: sessionStorage.getItem(BIZ_USERINFO) ? JSON.parse(sessionStorage.getItem(BIZ_USERINFO)) : null,
    currentCart: sessionStorage.getItem(BIZ_CURRENT_CART) ? JSON.parse(sessionStorage.getItem(BIZ_CURRENT_CART)) : null,
    cartItems: sessionStorage.getItem(BIZ_CART_ITEMS) ? JSON.parse(sessionStorage.getItem(BIZ_CART_ITEMS)) : null,
    historyData: [],
    searchValue: '',
    headers: {
      'Authorization': '',
      'username': '',
      'UserId': '',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Max-Age': 86400,
      'messages': null,
    },
    headersJson: {
      'Authorization': '',
      'username': '',
      'UserId': '',
      'Content-Type': 'application/json',
      'messages': null,
    },
    headersFile: {
      'Authorization': '',
      'username': '',
      'UserId': '',
      'messages': null,
    },
  },
  // plugins: [
  //   createPersistedState({
  //     paths: ["userInfo", "cart"],
  //     storage: window.localStorage
  //   }),
  // ],
  mutations: {
    SETLANG(state, lang) {
      state.lang = lang;
      localStorage.setItem(BIZ_LANG, lang);
    },
    SETTOKEN(state, val) {
      state.token = val;
      sessionStorage.setItem(BIZ_TOKEN, val);
    },
    SETHANDERS(state, data) {
      state.headers = {
        'Authorization': data.authorization,
        'username': data.username,
        'UserId': data.userId,
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Max-Age': 86400,
        'messages': null,
      },
        state.headersJson = {
          'Authorization': data.authorization,
          'username': data.username,
          'UserId': data.userId,
          'Content-Type': 'application/json',
          'messages': null,
        },
        state.headersFile = {
          'Authorization': data.authorization,
          'username': data.username,
          'UserId': data.userId,
          'messages': null,
        }
    },
    SETUSERINFO(state, userInfo) {
      state.userInfo = { ...userInfo };
      sessionStorage.setItem(BIZ_USERINFO, JSON.stringify(userInfo));
    },
    SETHISTORYDATA(state, data) {
      state.historyData = data
    },
    SETISLOGIN(state, data) {
      state.isLogin = data
    },
    SETCURRENTCART(state, data) {
      state.currentCart = { ...data };
      sessionStorage.setItem(BIZ_CURRENT_CART, JSON.stringify(data));
    },
    SETCARTQUANTITY(state, data) {
      state.cartQuantity = data
    },
    SETCARTITEMS(state, data) {
      state.cartItems = data;
      sessionStorage.setItem(BIZ_CART_ITEMS, JSON.stringify(data));
    },
    UPDATECARTITEMS(state,data) {
      // 更新数量
      if (state.cartItems && state.cartItems.length>0) {
        if (-1<data.index && data.quantity) {
          state.cartItems[data.index].quantity = data.quantity;
          state.cartItems[data.index].subtotal = data.quantity*state.cartItems[data.index].price;
         
        }
        if (-1<data.index && data.checked) {
          state.cartItems[data.index].checked = data.checked;
        }
        sessionStorage.setItem(BIZ_CART_ITEMS, JSON.stringify(state.cartItems));
      }
    },
    REMOVECARTITEMS(state,itemIndex) {
      // 更新数量
      if (-1<itemIndex && state.cartItems && state.cartItems.length) {
        // const newArray = array.filter(obj => obj.id !== idToRemove);
        state.cartItems.splice(itemIndex, 1);
        sessionStorage.setItem(BIZ_CART_ITEMS, JSON.stringify(state.cartItems));
      }
    },
    CLEARCART(state) {
      state.cartItems = [];
      state.currentCart = {};
      sessionStorage.removeItem(BIZ_CURRENT_CART);
      sessionStorage.removeItem(BIZ_CART_ITEMS);
    },
    LOADCARTITEMS(state) {
      if (state.currentCart && state.currentCart.id) {
        get_current({
          "currentCartId": state.currentCart.id
        }).then(response => {
          if(response.data.data.cartItems){
            state.cartItems = response.data.data.cartItems;
            sessionStorage.setItem(BIZ_CART_ITEMS, JSON.stringify(response.data.data.cartItems));
          }
        });
      }
    },
    UPDATESEARCHVALUE(state, val) {
      state.searchValue = val;
    },


    // commit('SET_ACCESS_TOKEN', data.access_token)
    // commit('SET_REFRESH_TOKEN', data.refresh_token)
  },
  actions: {
    asyncToken(context, val) {
      context.commit("SETTOKEN", val);
    },
    async getUserInfo({ commit }) {
      try {

        const userInfo = await UserInfoApi();

        commit("SETUSERINFO", userInfo.data);
        return Promise.resolve();
      } catch (error) {
        console.log('error ->', error);
        return Promise.reject();
      }
    },
    async logout({ commit }) {
      //清空当前用户
      //清空购物车
      // 清空购物车数量
      // 清空搜索历史

      commit("SETUSERINFO", {});
      commit("CLEARCART", []);
      commit('SETTOKEN', '');
      sessionStorage.removeItem(BIZ_TOKEN);
      showI18nMessage('message.home.operationSuccess')
      return Promise.resolve();
    },
  },
  getters: {
    existToken: (state) => {
      const token = sessionStorage.getItem(BIZ_TOKEN);
      if (token) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * 用户缓存
     * userInfoStorage
     * @param {*} state 
     * @returns 
     */
    userInfo: (state) => state.userInfo,

    /**
     * 是否登录
     * @param {*} state 
     * @returns 
     */
    isLogin: (state) => !!state.token,

    /**
     * 当前语言
     * @param {*} state 
     * @returns 
     */
    currentLang: (state) => state.lang,
    /**
     * 搜索历史
     * historyKeywordList
     * @param {*} state 
     * @returns 
     */
    historyData: (state) => state.historyData,
    /**
     * 当前购物车
     * @param {*} state 
     * @returns 
     */
    currentCart: (state) => state.currentCart,
    /**
     * 购物车商品项
     * @param {*} state 
     * @returns 
     */
    cartItems: (state) => state.cartItems,
    /**
     * 购物车商品数量
     * @param {*} state 
     * @returns 
     */
    cartQuantity: (state) => state.cartQuantity,

    /**
     * get请求方法头
     * @param {*} state 
     * @returns 
     */
    headers: (state) => state.headers,

    /**
     * post请求方法头
     * @param {*} state 
     * @returns 
     */
    headersJson: (state) => state.headersJson,

    /**
     * file传递方法头
     * @param {*} state 
     * @returns 
     */
    headersFile: (state) => state.headersFile,

    /**
     * 搜索词
     * @param {*} state 
     * @returns 
     */
    searchValue: (state) => state.searchValue,
  },
});
